import qs from 'qs';
import UnknownObject from '../../types/UnknownObject';

/**
  getParameterByName is deprecated
  use parseQueryString below
 */
export function getParameterByName(name: string, url: string): string | null {
  const validName = name.replace(/[\[\]]/g, '\\$&');
  const validUrl = url || window.location.href;

  const regex = new RegExp(`[?&]${validName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(validUrl);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parseQueryString = (queryString: string) =>
  qs.parse(queryString, { ignoreQueryPrefix: true, arrayLimit: 50 });

export const generateQueryString = (params: UnknownObject, useExplicitIndices = false): string => {
  const arrayFormat = useExplicitIndices ? 'indices' : 'brackets';

  return qs.stringify(params, { arrayFormat });
};
